(function () {
    'use strict';

    angular
        .module('appback')
        .controller('PetitionController', PetitionController)

    PetitionController.$inject = ["PetitionService", "$q"];

    // Requisición de almacén sin tarjeta: mismos campos y comprobaciones que la
    // requisición de la tarjeta Kanban (kanban.controller.js), pero sin almacén
    // de origen preseleccionado.
    function PetitionController(PetitionService, $q) {

        var vm = this;

        // Textos traducibles: la clave es el texto en inglés y la traducción
        // llega de petition/index.twig (window.petitionI18n).
        function tr(text) {
            var dict = window.petitionI18n || {};
            return dict[text] || text;
        }

        vm.petitions = [];
        vm.warehouses = [];
        // Centros de costo activos del CRM: [{code, name}].
        vm.costCenters = [];
        // Personas del "Solicitado por": se cargan por páginas al bajar en el
        // desplegable, igual que las piezas (ver newRequisitionItem).
        vm.people = newDropdownList('people');

        vm.requisition = null;
        vm.requisitionSearch = { origin: '', destination: '', costCenter: '' };
        vm.fieldErrors = {};

        vm.loading = false;
        vm.sending = false;
        vm.successMessage = '';
        vm.errorMessage = '';
        // Detalle del error o avisos (p. ej. piezas que fallaron en SAP).
        vm.messageDetails = [];

        // Elementos (piezas, servicios, personas) que se piden al servidor por
        // página: al desplegar se cargan los primeros y al llegar al final del
        // scroll, los siguientes.
        var DROPDOWN_PAGE = 30;

        vm.init = function () {

            vm.loading = true;

            vm.resetForm();

            PetitionService.getData().then(function (data) {

                if (!data || !data.petitions) {
                    return $q.reject(data);
                }

                vm.petitions = data.petitions || [];

                // Por defecto lo pide la persona del usuario conectado.
                if (data.currentPersonal && data.currentPersonal.id && !vm.requisition.requested_by_id) {
                    vm.requisition.requested_by_id = String(data.currentPersonal.id);
                    vm.requisition.requested_by_label = [data.currentPersonal.name, data.currentPersonal.surname].filter(Boolean).join(' ');
                }

            }).catch(function () {
                vm.errorMessage = tr('Could not load the form data.');
            }).finally(function () {
                vm.loading = false;
            });

            PetitionService.getWarehouses().then(function (data) {
                if (!data || !data.success) {
                    return $q.reject(data);
                }
                vm.warehouses = withStringIds(data.warehouses);
            }).catch(function () {
                vm.errorMessage = tr('Could not get the warehouses.');
            });

            PetitionService.getCostCenters().then(function (data) {
                if (!data || !data.success) {
                    return $q.reject(data);
                }
                vm.costCenters = data.cost_centers || [];
            }).catch(function () {
                vm.errorMessage = tr('Could not get the cost centers.');
            });
        };

        function withStringIds(items) {
            return (items || []).map(function (item) {
                return angular.extend({}, item, { id: String(item.id) });
            });
        }

        function findById(list, id) {
            return (list || []).find(function (item) {
                return String(item.id) === String(id);
            }) || null;
        }

        // Lista de un desplegable que se carga por páginas desde el servidor:
        // guarda la búsqueda, los resultados y si está cargando. kind indica
        // qué se busca: 'part', 'service' o 'people'.
        function newDropdownList(kind) {
            return {
                kind: kind,
                search: '',
                results: [],
                offset: 0,
                hasMore: false,
                loading: false,
                loaded: false,
                requestId: 0
            };
        }

        function newRequisitionItem(isService) {
            return angular.extend(newDropdownList(isService ? 'service' : 'part'), {
                // Servicio (productos de tipo SERVICIOS) o pieza del almacén.
                isService: !!isService,
                product_id: null,
                product_label: '',
                quantity: null
            });
        }

        // Vacía el formulario; se conserva el solicitante.
        vm.resetForm = function () {

            var previous = vm.requisition || {};

            vm.requisition = {
                warehouse_id: null,
                warehousedestiny_id: null,
                cost_center: null,
                // 'parts' o 'services': por defecto, piezas.
                type: 'parts',
                requested_by_id: previous.requested_by_id || null,
                requested_by_label: previous.requested_by_label || '',
                observations: '',
                items: [newRequisitionItem()],
                services: [newRequisitionItem(true)]
            };

            vm.requisitionSearch = { origin: '', destination: '', costCenter: '' };
            vm.fieldErrors = {};
        };

        vm.clearFieldError = function (key) {
            delete vm.fieldErrors[key];
        };

        // Cierra el desplegable de Bootstrap desde el que se eligió una opción.
        function closeDropdown(event) {

            if (!event) {
                return;
            }

            var dropdownEl = event.currentTarget ? event.currentTarget.closest('.dropdown') : null;
            var toggleEl = dropdownEl ? dropdownEl.querySelector('[data-bs-toggle="dropdown"]') : null;

            if (!toggleEl || !window.bootstrap || !window.bootstrap.Dropdown) {
                return;
            }

            (window.bootstrap.Dropdown.getInstance(toggleEl) || new window.bootstrap.Dropdown(toggleEl)).hide();
        }

        // Pide una página de la lista según su tipo (kind).
        function fetchDropdownPage(item, offset) {

            if (item.kind === 'people') {
                return PetitionService.getUsers(item.search, offset, DROPDOWN_PAGE);
            }

            // Solo piezas del almacén de origen elegido; los servicios no
            // dependen del almacén.
            return item.kind === 'service'
                ? PetitionService.getServiceProducts(item.search, offset, DROPDOWN_PAGE)
                : PetitionService.getPetitionProducts(item.search, offset, DROPDOWN_PAGE, vm.requisition.warehouse_id);
        }

        var DROPDOWN_ERRORS = {
            part: 'Could not search the parts.',
            service: 'Could not search the services.',
            people: 'Error getting the users.'
        };

        // Carga una página de piezas, servicios o personas. reset = true
        // empieza de cero (nueva búsqueda); si no, añade la página siguiente.
        function loadDropdownPage(item, reset) {

            var requestId = ++item.requestId;
            var offset = reset ? 0 : item.offset;

            item.loading = true;

            return fetchDropdownPage(item, offset).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Se descartan las respuestas de búsquedas ya superadas.
                if (requestId !== item.requestId) {
                    return;
                }

                var page = withStringIds(item.kind === 'people' ? data.users : data.products);

                if (reset) {
                    item.results = page;
                } else {
                    // Un elemento puede llegar repetido en otra página: se descarta.
                    var known = {};

                    item.results.forEach(function (product) {
                        known[product.id] = true;
                    });

                    item.results = item.results.concat(page.filter(function (product) {
                        return !known[product.id];
                    }));
                }

                item.offset = offset + DROPDOWN_PAGE;
                item.hasMore = !!data.has_more;
                item.loaded = true;

            }).catch(function () {

                if (requestId === item.requestId) {
                    vm.errorMessage = tr(DROPDOWN_ERRORS[item.kind]);
                }

            }).finally(function () {

                if (requestId === item.requestId) {
                    item.loading = false;
                }
            });
        }

        // Nueva búsqueda (al escribir): vuelve a la primera página.
        vm.searchDropdownList = function (item) {
            return loadDropdownPage(item, true);
        };

        // Al llegar al final de la lista se pide la página siguiente.
        vm.showMoreDropdownList = function (item) {
            if (item.hasMore && !item.loading) {
                loadDropdownPage(item, false);
            }
        };

        // Al abrir el desplegable por primera vez se carga la primera página.
        vm.openDropdownList = function (item) {
            if (!item.loaded && !item.loading) {
                loadDropdownPage(item, true);
            }
        };

        // Al cambiar el almacén de origen las piezas ya elegidas o cargadas
        // pueden no estar en él: se vacían y se vuelven a pedir al desplegar.
        function resetRequisitionProducts() {

            vm.requisition.items.forEach(function (item) {
                item.product_id = null;
                item.product_label = '';
                item.results = [];
                item.offset = 0;
                item.hasMore = false;
                item.loaded = false;
                item.loading = false;
                // Descarta las respuestas pendientes del almacén anterior.
                item.requestId++;
            });
        }

        // Mismo almacén: mismo id o mismo código de SAP.
        function isSameWarehouse(warehouseA, warehouseB) {

            if (!warehouseA || !warehouseB) {
                return false;
            }

            var codeA = String(warehouseA.code || '').trim().toLowerCase();
            var codeB = String(warehouseB.code || '').trim().toLowerCase();

            return String(warehouseA.id) === String(warehouseB.id) || (codeA !== '' && codeA === codeB);
        }

        // La lista de almacenes de destino no incluye el de origen.
        vm.isRequisitionDestinationCandidate = function (warehouse) {
            return !vm.requisition || !isSameWarehouse(warehouse, findById(vm.warehouses, vm.requisition.warehouse_id));
        };

        function clearDestinationIfSameAsOrigin() {

            var origin = findById(vm.warehouses, vm.requisition.warehouse_id);
            var destination = findById(vm.warehouses, vm.requisition.warehousedestiny_id);

            if (isSameWarehouse(origin, destination)) {
                vm.requisition.warehousedestiny_id = null;
            }
        }

        // Al salir del campo la cantidad se deja entera: se quita la parte
        // decimal y si es menor que 1 se pone a 1.
        vm.normalizeRequisitionQuantity = function (item, index) {

            if (item.quantity === null || item.quantity === undefined || item.quantity === '') {
                return;
            }

            var quantity = Math.trunc(Number(item.quantity));

            if (isNaN(quantity)) {
                return;
            }

            item.quantity = quantity < 1 ? 1 : quantity;
            vm.clearFieldError('requisition.' + (item.isService ? 'services' : 'items') + '.' + index + '.quantity');
        };

        vm.addRequisitionItem = function () {
            vm.requisition.items.push(newRequisitionItem());
        };

        vm.removeRequisitionItem = function (index) {
            removeFromList('items', index);
        };

        vm.addRequisitionService = function () {
            vm.requisition.services.push(newRequisitionItem(true));
        };

        vm.removeRequisitionService = function (index) {
            removeFromList('services', index);
        };

        function removeFromList(listName, index) {

            if (vm.requisition[listName].length <= 1) {
                return;
            }

            vm.requisition[listName].splice(index, 1);

            // Los errores de cada línea van por posición: se recalculan al enviar.
            Object.keys(vm.fieldErrors).forEach(function (key) {
                if (key.indexOf('requisition.' + listName + '.') === 0) {
                    delete vm.fieldErrors[key];
                }
            });
        }

        vm.getWarehouseLabel = function (id) {
            var warehouse = findById(vm.warehouses, id);

            return warehouse ? warehouse.name + (warehouse.code ? ' (' + warehouse.code + ')' : '') : '';
        };

        vm.getCostCenterLabel = function (code) {
            var costCenter = (vm.costCenters || []).find(function (item) {
                return String(item.code) === String(code);
            });

            return costCenter ? costCenter.name + ' (' + costCenter.code + ')' : code;
        };

        vm.selectRequisitionPerson = function (person, event) {
            vm.requisition.requested_by_id = person.id;
            vm.requisition.requested_by_label = person.name;
            vm.clearFieldError('requisition.requested_by_id');
            closeDropdown(event);
        };

        vm.selectRequisitionField = function (field, value, errorKey, event) {

            var warehouseChanged = field === 'warehouse_id' && String(vm.requisition.warehouse_id) !== String(value);

            vm.requisition[field] = value;

            if (warehouseChanged) {
                resetRequisitionProducts();
                clearDestinationIfSameAsOrigin();
            }

            vm.clearFieldError(errorKey);
            closeDropdown(event);
        };

        vm.selectRequisitionType = function (type) {
            vm.requisition.type = type;
            vm.clearFieldError('requisition.type');
        };

        vm.selectRequisitionProduct = function (item, index, product, event) {
            item.product_id = product.id;
            item.product_label = product.name + (product.itemcode ? ' · ' + product.itemcode : '');
            vm.clearFieldError('requisition.' + (item.isService ? 'services' : 'items') + '.' + index + '.product');
            closeDropdown(event);
        };

        // Popup de peticiones pendientes: lista paginada para aceptarlas o rechazarlas.
        var PENDING_PAGE_SIZE = 10;

        vm.pending = {
            petitions: [],
            page: 1,
            total: 0,
            loading: false,
            // Id de la petición que se está aceptando o rechazando (una cada vez).
            resolvingId: null,
            successMessage: '',
            errorMessage: ''
        };

        vm.pendingKindLabel = function (kind) {
            return tr({ transfer: 'Transfer', pickup: 'Pickup', pickup_return: 'Pickup return' }[kind] || kind);
        };

        vm.pendingPageCount = function () {
            return Math.max(1, Math.ceil(vm.pending.total / PENDING_PAGE_SIZE));
        };

        vm.loadPending = function (page) {

            vm.pending.loading = true;

            return PetitionService.getPendingPetitions(page, PENDING_PAGE_SIZE).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.pending.petitions = data.petitions || [];
                vm.pending.total = data.total || 0;
                vm.pending.page = data.page || 1;

            }).catch(function () {
                vm.pending.errorMessage = tr('Could not load the pending requests.');
            }).finally(function () {
                vm.pending.loading = false;
            });
        };

        vm.openPendingModal = function () {

            vm.pending.successMessage = '';
            vm.pending.errorMessage = '';
            vm.loadPending(1);

            var modalEl = document.getElementById('pendingPetitionsModal');

            if (modalEl && window.bootstrap && window.bootstrap.Modal) {
                window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
            }
        };

        // Acepta o rechaza una petición (crea o cierra el documento en SAP) y recarga la página actual.
        vm.resolvePending = function (petition, accept) {

            if (vm.pending.resolvingId) {
                return;
            }

            vm.pending.resolvingId = petition.id;
            vm.pending.successMessage = '';
            vm.pending.errorMessage = '';

            return PetitionService.resolvePetition(petition.id, accept).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.pending.successMessage = data.message || '';
                // Refresca también la tabla de últimas peticiones de la pantalla.
                vm.petitions = data.petitions || vm.petitions;

                return vm.loadPending(vm.pending.page);

            }).catch(function (error) {

                var body = error && error.data ? error.data : error;

                vm.pending.errorMessage = (body && body.message) || tr(accept ? 'Could not accept the request.' : 'Could not reject the request.');

            }).finally(function () {
                vm.pending.resolvingId = null;
            });
        };

        // Popup de devoluciones: primero se elige una petición completada (lista paginada) y después
        // la cantidad a devolver, quién la pide y las notas. Se crea con los almacenes al revés.
        var RETURNS_PAGE_SIZE = 10;

        vm.returns = {
            // 'list' (elegir la petición) o 'form' (datos de la devolución)
            step: 'list',
            petitions: [],
            offset: 0,
            hasMore: false,
            loading: false,
            selected: null,
            form: null,
            people: newDropdownList('people'),
            sending: false,
            fieldErrors: {},
            successMessage: '',
            errorMessage: '',
            messageDetails: []
        };

        vm.returnsPage = function () {
            return Math.floor(vm.returns.offset / RETURNS_PAGE_SIZE) + 1;
        };

        vm.loadReturnable = function (offset) {

            vm.returns.loading = true;

            return PetitionService.getReturnablePetitions(Math.max(0, offset), RETURNS_PAGE_SIZE).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.returns.petitions = data.petitions || [];
                vm.returns.hasMore = !!data.has_more;
                vm.returns.offset = Math.max(0, offset);

            }).catch(function () {
                vm.returns.errorMessage = tr('Could not load the completed requests.');
            }).finally(function () {
                vm.returns.loading = false;
            });
        };

        function clearReturnMessages() {
            vm.returns.successMessage = '';
            vm.returns.errorMessage = '';
            vm.returns.messageDetails = [];
        }

        vm.openReturnModal = function () {

            clearReturnMessages();
            vm.returns.step = 'list';
            vm.returns.selected = null;
            vm.loadReturnable(0);

            var modalEl = document.getElementById('returnPetitionsModal');

            if (modalEl && window.bootstrap && window.bootstrap.Modal) {
                window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
            }
        };

        // Lo que queda por devolver de una petición: lo pedido menos sus devoluciones (no rechazadas).
        vm.returnableQuantity = function (petition) {
            return Number(petition && petition.returnable_quantity) || 0;
        };

        // Paso 2: datos de la devolución de la petición elegida. Por defecto se devuelve todo lo
        // que queda por devolver y la pide la misma persona que la requisición.
        vm.selectReturn = function (petition) {

            clearReturnMessages();
            vm.returns.selected = petition;
            vm.returns.fieldErrors = {};
            vm.returns.form = {
                quantity: vm.returnableQuantity(petition) || 1,
                requested_by_id: vm.requisition.requested_by_id,
                requested_by_label: vm.requisition.requested_by_label,
                observations: ''
            };
            vm.returns.step = 'form';
        };

        vm.backToReturnList = function () {
            clearReturnMessages();
            vm.returns.step = 'list';
            vm.returns.selected = null;
        };

        vm.selectReturnPerson = function (person, event) {
            vm.returns.form.requested_by_id = person.id;
            vm.returns.form.requested_by_label = person.name;
            delete vm.returns.fieldErrors.requested_by_id;
            closeDropdown(event);
        };

        vm.sendReturn = function () {

            var form = vm.returns.form;
            var max = vm.returnableQuantity(vm.returns.selected);
            var quantity = Number(form.quantity);
            var errors = {};

            clearReturnMessages();

            if (!quantity || quantity < 1 || Math.floor(quantity) !== quantity || quantity > max) {
                errors.quantity = tr('The quantity to return must be a whole number between 1 and {max}.').replace('{max}', max);
            }

            if (!form.requested_by_id) {
                errors.requested_by_id = tr('You must indicate who is making the request.');
            }

            vm.returns.fieldErrors = errors;

            if (Object.keys(errors).length) {
                return;
            }

            vm.returns.sending = true;

            return PetitionService.createReturn({
                request_id: vm.returns.selected.id,
                quantity: quantity,
                requested_by_id: form.requested_by_id,
                observations: (form.observations || '').trim()
            }).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Refresca también la tabla de últimas peticiones de la pantalla.
                vm.petitions = data.petitions || vm.petitions;

                if (data.errors && data.errors.length) {
                    // Creada en el CRM, pero SAP falló: se puede ver en el historial
                    vm.returns.errorMessage = tr('The return was created, but there were problems in SAP.');
                    vm.returns.messageDetails = data.errors;
                } else {
                    vm.returns.successMessage = tr(data.pending ? 'Return registered in SAP. It is pending approval.' : 'Return registered correctly in SAP.');
                }

                vm.returns.step = 'list';
                vm.returns.selected = null;

                return vm.loadReturnable(vm.returns.offset);

            }).catch(function (error) {

                var body = error && error.data ? error.data : error;

                vm.returns.errorMessage = (body && body.message) || tr('Could not create the return.');
                vm.returns.messageDetails = (body && body.errors) || [];

            }).finally(function () {
                vm.returns.sending = false;
            });
        };

        vm.submit = function () {

            var requisition = vm.requisition;
            var errors = {};

            vm.successMessage = '';
            vm.errorMessage = '';
            vm.messageDetails = [];

            if (!requisition.warehouse_id) {
                errors['requisition.warehouse_id'] = tr('You must select the source warehouse.');
            }

            // Sin destino es una recogida: el destino es opcional.
            if (requisition.warehousedestiny_id && isSameWarehouse(findById(vm.warehouses, requisition.warehouse_id), findById(vm.warehouses, requisition.warehousedestiny_id))) {
                errors['requisition.warehousedestiny_id'] = tr('The source and destination warehouses cannot be the same.');
            }

            if (!requisition.requested_by_id) {
                errors['requisition.requested_by_id'] = tr('You must indicate who is making the request.');
            }

            if (!requisition.cost_center) {
                errors['requisition.cost_center'] = tr('You must select a cost center.');
            }

            if (!requisition.type) {
                errors['requisition.type'] = tr('You must indicate whether the requisition is for parts or services.');
            } else if (requisition.type === 'services') {
                // Los servicios ya se pueden elegir, pero todavía no se envían.
                errors['requisition.type'] = tr('Services cannot be requested yet.');
            }

            (requisition.type === 'parts' ? requisition.items : []).forEach(function (item, index) {

                if (!item.product_id) {
                    errors['requisition.items.' + index + '.product'] = tr('You must select a part.');
                }

                var quantity = Number(item.quantity);

                if (!quantity || quantity < 1 || Math.floor(quantity) !== quantity) {
                    errors['requisition.items.' + index + '.quantity'] = tr('Enter a whole quantity of at least 1.');
                }
            });

            vm.fieldErrors = errors;

            if (Object.keys(errors).length) {
                return;
            }

            var payload = {
                warehouse_id: requisition.warehouse_id,
                warehousedestiny_id: requisition.warehousedestiny_id,
                cost_center: requisition.cost_center,
                requested_by_id: requisition.requested_by_id,
                observations: (requisition.observations || '').trim(),
                items: requisition.items.map(function (item) {
                    return { product_id: item.product_id, quantity: Number(item.quantity) };
                })
            };

            vm.sending = true;

            return PetitionService.createRequisition(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.petitions = data.petitions || vm.petitions;

                vm.resetForm();

                // Alguna pieza pudo fallar (p. ej. en SAP) aunque se crearan otras.
                if (data.errors && data.errors.length) {
                    vm.errorMessage = tr('The requisition was created, but there were problems with some parts.');
                    vm.messageDetails = data.errors.concat(data.warnings || []);
                } else if (data.pending) {
                    // Recogidas: quedan como borrador de salida hasta que se acepten.
                    vm.successMessage = tr('Requisition registered in SAP. The requests are pending approval.');
                    vm.messageDetails = data.warnings || [];
                } else {
                    vm.successMessage = tr('Requisition registered correctly in SAP.');
                    // P. ej. las observaciones se cortaron a 254 caracteres.
                    vm.messageDetails = data.warnings || [];
                }

            }).catch(function (error) {

                var body = error && error.data ? error.data : error;

                vm.errorMessage = (body && body.message) || tr('Could not create the requisition.');
                vm.messageDetails = (body && body.errors) || [];

            }).finally(function () {

                vm.sending = false;
            });
        };
    }
})();
